module.exports = __webpack_public_path__ + "assets/img/about-bg_01.e1fc83dd.png";